import { EventEmitter, Component, Output, Injectable, ComponentFactoryResolver, ApplicationRef, Injector, ɵɵdefineInjectable, ɵɵinject, INJECTOR, ChangeDetectorRef, ElementRef, NgZone, ChangeDetectionStrategy, NgModule, Directive, ViewContainerRef, Input, Optional, ViewChild, InjectionToken, APP_INITIALIZER } from '@angular/core';
import { CommonModule, DOCUMENT } from '@angular/common';
import { applyPolyfills, defineCustomElements } from '@se/web-ui/loader';
import { __decorate, __metadata } from 'tslib';
import { fromEvent } from 'rxjs';

/**
 * @fileoverview added by tsickle
 * Generated from: lib/initialize.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @param {?} doc
 * @return {?}
 */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';

const _c0 = ["*"];
function DialogComponent_se_dialog_header_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "se-dialog-header");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.dialog.title);
} }
function DialogComponent_se_dialog_footer_4_Template(rf, ctx) { if (rf & 1) {
    const _r4 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "se-dialog-footer")(1, "se-button", 4);
    ɵngcc0.ɵɵlistener("click", function DialogComponent_se_dialog_footer_4_Template_se_button_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r3 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r3.closeDialog()); });
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r1.dialog.textOK || "Ok");
} }
function DialogComponent_se_dialog_footer_5_Template(rf, ctx) { if (rf & 1) {
    const _r6 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "se-dialog-footer")(1, "se-button", 5);
    ɵngcc0.ɵɵlistener("click", function DialogComponent_se_dialog_footer_5_Template_se_button_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r5 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r5.cancelDialog()); });
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "se-button", 4);
    ɵngcc0.ɵɵlistener("click", function DialogComponent_se_dialog_footer_5_Template_se_button_click_3_listener() { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r7 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r7.closeDialog()); });
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r2.dialog.textCancel || "Cancel");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r2.dialog.textOK || "Ok");
} }
function DialogModalComponent_ng_template_1_Template(rf, ctx) { }
const _c1 = "[_nghost-%COMP%]{display:flex;flex-direction:column}";
function appInitialize(doc) {
    return (/**
     * @return {?}
     */
    () => {
        return applyPolyfills().then((/**
         * @return {?}
         */
        () => {
            return defineCustomElements();
        }));
    });
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/snackbar/snackbar-config.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * \@description Configuration for opening snackbar with the SnackbarService.
 */
class SnackbarConfig {
    constructor() {
        /**
         * \@description type of snackbar :'success' | 'error' | 'warning' | 'information'
         */
        this.type = 'information';
        /**
         * \@description time duration for which snackbar will be displayed.
         */
        this.duration = 5000;
    }
}
if (false) {
    /**
     * \@description type of snackbar :'success' | 'error' | 'warning' | 'information'
     * @type {?}
     */
    SnackbarConfig.prototype.type;
    /**
     * \@description message value passed to display in snackbar component.
     * @type {?}
     */
    SnackbarConfig.prototype.message;
    /**
     * \@description icon value is passed to display in snackbar component
     * @type {?}
     */
    SnackbarConfig.prototype.icon;
    /**
     * \@description indicates if the snackbar is open, set to `false` (closed) by default
     * @type {?}
     */
    SnackbarConfig.prototype.open;
    /**
     * \@description canClose boolean flag to set whether close button is required in snackbar component.
     * @type {?}
     */
    SnackbarConfig.prototype.canClose;
    /**
     * \@description actionText passed to displayed on action button in snackbar component.
     * @type {?}
     */
    SnackbarConfig.prototype.actionText;
    /**
     * \@description time duration for which snackbar will be displayed.
     * @type {?}
     */
    SnackbarConfig.prototype.duration;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/snackbar/snackbar.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class SnackbarComponent {
    /**
     * @param {?} config
     */
    constructor(config) {
        this.config = config;
        /**
         * \@description on close even emitter
         */
        this.didClose = new EventEmitter();
        this.actionClicked = new EventEmitter();
    }
    /**
     * \@name closeEvent
     * \@description event emitter on closing of snackbar from angular component
     * @return {?}
     */
    closeEvent() {
        this.didClose.emit(this.config);
    }
    /**
     * \@name actionClicked
     * \@description event emitter on clicking snackbar action button from angular component
     * @return {?}
     */
    actionClickedEvent() {
        this.actionClicked.emit(this.config);
    }
}
SnackbarComponent.ɵfac = function SnackbarComponent_Factory(t) { return new (t || SnackbarComponent)(ɵngcc0.ɵɵdirectiveInject(SnackbarConfig)); };
SnackbarComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: SnackbarComponent, selectors: [["se-ng-snackbar"]], outputs: { didClose: "didClose", actionClicked: "actionClicked" }, decls: 1, vars: 7, consts: [[3, "open", "type", "icon", "message", "canClose", "actionText", "duration", "didClose", "actionClicked"]], template: function SnackbarComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "se-snackbar", 0);
        ɵngcc0.ɵɵlistener("didClose", function SnackbarComponent_Template_se_snackbar_didClose_0_listener() { return ctx.closeEvent(); })("actionClicked", function SnackbarComponent_Template_se_snackbar_actionClicked_0_listener() { return ctx.actionClickedEvent(); });
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("open", true)("type", ctx.config.type)("icon", ctx.config.icon)("message", ctx.config.message)("canClose", ctx.config.canClose)("actionText", ctx.config.actionText)("duration", ctx.config.duration);
    } }, dependencies: function () { return [SeSnackbar]; }, styles: [_c1] });
/** @nocollapse */
SnackbarComponent.ctorParameters = () => [
    { type: SnackbarConfig }
];
SnackbarComponent.propDecorators = {
    didClose: [{ type: Output }],
    actionClicked: [{ type: Output }]
};
if (false) {
    /**
     * \@description on close even emitter
     * @type {?}
     */
    SnackbarComponent.prototype.didClose;
    /** @type {?} */
    SnackbarComponent.prototype.actionClicked;
    /** @type {?} */
    SnackbarComponent.prototype.config;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/shared/component-injector.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ComponentInjector {
    /**
     * @param {?} _parentInjector
     * @param {?} _additionalTokens
     */
    constructor(_parentInjector, _additionalTokens) {
        this._parentInjector = _parentInjector;
        this._additionalTokens = _additionalTokens;
    }
    /**
     * @param {?} token
     * @param {?=} notFoundValue
     * @param {?=} flags
     * @return {?}
     */
    get(token, notFoundValue, flags) {
        /** @type {?} */
        const value = this._additionalTokens.get(token);
        return value ? value : this._parentInjector.get(token, notFoundValue);
    }
}
if (false) {
    /**
     * @type {?}
     * @private
     */
    ComponentInjector.prototype._parentInjector;
    /**
     * @type {?}
     * @private
     */
    ComponentInjector.prototype._additionalTokens;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/snackbar/snackbar.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class SnackbarService {
    /**
     * @param {?} componentFactoryResolver
     * @param {?} appRef
     * @param {?} injector
     */
    constructor(componentFactoryResolver, appRef, injector) {
        this.componentFactoryResolver = componentFactoryResolver;
        this.appRef = appRef;
        this.injector = injector;
        this.defaultConfig = {
            type: 'information',
            icon: 'information_circle',
            canClose: false,
            duration: 5000,
            message: ''
        };
    }
    /**
     * \@name appendSnackbarComponentToBody
     * \@description method to append the component to document body
     * @param {?} config : configuration value of type SnackbarConfig
     * @return {?} reference of sncackbar componenet created
     */
    appendSnackbarComponentToBody(config) {
        //create a map with the config
        /** @type {?} */
        const map = new WeakMap();
        map.set(SnackbarConfig, config);
        /** @type {?} */
        const componentFactory = this.componentFactoryResolver.resolveComponentFactory(SnackbarComponent);
        /** @type {?} */
        const componentRef = componentFactory.create(new ComponentInjector(this.injector, map));
        this.appRef.attachView(componentRef.hostView);
        /** @type {?} */
        const domElem = (/** @type {?} */ (((/** @type {?} */ (componentRef.hostView))).rootNodes[0]));
        document.body.appendChild(domElem);
        this.snackbarComponentRef = componentRef;
        //returning snackbar component reference
        return this.snackbarComponentRef;
    }
    /**
     * \@name removeSnackBarComponent
     * \@description method to remove / detach snackbar component from document body
     * @return {?}
     */
    removeSnackBarComponent() {
        this.appRef.detachView(this.snackbarComponentRef.hostView);
        this.snackbarComponentRef.destroy();
    }
    /**
     * \@name open
     * \@description method to open snackbar
     * @param {?} config
     * @return {?} reference of snackbar component
     */
    open(config) {
        if (this.snackbarComponentRef) {
            this.removeSnackBarComponent();
        }
        /** @type {?} */
        const userConf = Object.assign({}, this.defaultConfig, config);
        /** @type {?} */
        const ref = this.appendSnackbarComponentToBody(userConf);
        //subscribing SnackbarComponent instance event while closing snackbar
        /** @type {?} */
        const sub = this.snackbarComponentRef.instance.didClose.subscribe((/**
         * @return {?}
         */
        () => {
            this.removeSnackBarComponent();
            sub.unsubscribe();
        }));
        this.autoDismiss(userConf.canClose, userConf.duration);
        return ref;
    }
    /**
     * \@name autoDismiss
     * \@description method called if canClose attribute is false to close the snackbar authomatically
     * @param {?} canClose
     * @param {?} duration
     * @return {?}
     */
    autoDismiss(canClose, duration) {
        if (!canClose) {
            setTimeout((/**
             * @return {?}
             */
            () => {
                this.removeSnackBarComponent();
            }), duration);
        }
    }
}
SnackbarService.ɵfac = function SnackbarService_Factory(t) { return new (t || SnackbarService)(ɵngcc0.ɵɵinject(ɵngcc0.ComponentFactoryResolver), ɵngcc0.ɵɵinject(ɵngcc0.ApplicationRef), ɵngcc0.ɵɵinject(ɵngcc0.Injector)); };
SnackbarService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: SnackbarService, factory: SnackbarService.ɵfac, providedIn: 'root' });
/** @nocollapse */
SnackbarService.ctorParameters = () => [
    { type: ComponentFactoryResolver },
    { type: ApplicationRef },
    { type: Injector }
];
/** @nocollapse */ SnackbarService.ngInjectableDef = ɵɵdefineInjectable({ factory: function SnackbarService_Factory() { return new SnackbarService(ɵɵinject(ComponentFactoryResolver), ɵɵinject(ApplicationRef), ɵɵinject(INJECTOR)); }, token: SnackbarService, providedIn: "root" });
if (false) {
    /** @type {?} */
    SnackbarService.prototype.defaultConfig;
    /**
     * \@description ComponentRef of Snackbar Component
     * @type {?}
     */
    SnackbarService.prototype.snackbarComponentRef;
    /**
     * @type {?}
     * @private
     */
    SnackbarService.prototype.componentFactoryResolver;
    /**
     * @type {?}
     * @private
     */
    SnackbarService.prototype.appRef;
    /**
     * @type {?}
     * @private
     */
    SnackbarService.prototype.injector;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/directives/proxies-utils.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const proxyInputs = (/**
 * @param {?} Cmp
 * @param {?} inputs
 * @return {?}
 */
(Cmp, inputs) => {
    /** @type {?} */
    const Prototype = Cmp.prototype;
    inputs.forEach((/**
     * @param {?} item
     * @return {?}
     */
    item => {
        Object.defineProperty(Prototype, item, {
            /**
             * @return {?}
             */
            get() { return this.el[item]; },
            /**
             * @param {?} val
             * @return {?}
             */
            set(val) { this.z.runOutsideAngular((/**
             * @return {?}
             */
            () => (this.el[item] = val))); }
        });
    }));
});
/** @type {?} */
const proxyMethods = (/**
 * @param {?} Cmp
 * @param {?} methods
 * @return {?}
 */
(Cmp, methods) => {
    /** @type {?} */
    const Prototype = Cmp.prototype;
    methods.forEach((/**
     * @param {?} methodName
     * @return {?}
     */
    methodName => {
        Prototype[methodName] = (/**
         * @return {?}
         */
        function () {
            /** @type {?} */
            const args = arguments;
            return this.z.runOutsideAngular((/**
             * @return {?}
             */
            () => this.el[methodName].apply(this.el, args)));
        });
    }));
});
/** @type {?} */
const proxyOutputs = (/**
 * @param {?} instance
 * @param {?} el
 * @param {?} events
 * @return {?}
 */
(instance, el, events) => {
    events.forEach((/**
     * @param {?} eventName
     * @return {?}
     */
    eventName => instance[eventName] = fromEvent(el, eventName)));
})
// tslint:disable-next-line: only-arrow-functions
;
// tslint:disable-next-line: only-arrow-functions
/**
 * @param {?} opts
 * @return {?}
 */
function ProxyCmp(opts) {
    /** @type {?} */
    const decorator = (/**
     * @param {?} cls
     * @return {?}
     */
    function (cls) {
        if (opts.inputs) {
            proxyInputs(cls, opts.inputs);
        }
        if (opts.methods) {
            proxyMethods(cls, opts.methods);
        }
        return cls;
    });
    return decorator;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/directives/proxies.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
let SeAbout = class SeAbout {
    /**
     * @param {?} c
     * @param {?} r
     * @param {?} z
     */
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
};
SeAbout.ɵfac = function SeAbout_Factory(t) { return new (t || SeAbout)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
SeAbout.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: SeAbout, selectors: [["se-about"]], inputs: { appTitle: "appTitle", copyright: "copyright", domain: "domain", imageUrl: "imageUrl", version: "version" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function SeAbout_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
SeAbout.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
/** @nocollapse */
SeAbout.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
SeAbout = __decorate([
    ProxyCmp({ inputs: ['appTitle', 'copyright', 'domain', 'imageUrl', 'version'] }),
    __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])
], SeAbout);
if (false) {
    /**
     * @type {?}
     * @protected
     */
    SeAbout.prototype.el;
    /**
     * @type {?}
     * @protected
     */
    SeAbout.prototype.z;
}
let SeApp = class SeApp {
    /**
     * @param {?} c
     * @param {?} r
     * @param {?} z
     */
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['themeChanged']);
    }
};
SeApp.ɵfac = function SeApp_Factory(t) { return new (t || SeApp)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
SeApp.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: SeApp, selectors: [["se-app"]], inputs: { option: "option", theme: "theme" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function SeApp_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
SeApp.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
/** @nocollapse */
SeApp.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
SeApp = __decorate([
    ProxyCmp({ inputs: ['option', 'theme'] }),
    __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])
], SeApp);
if (false) {
    /** @type {?} */
    SeApp.prototype.themeChanged;
    /**
     * @type {?}
     * @protected
     */
    SeApp.prototype.el;
    /**
     * @type {?}
     * @protected
     */
    SeApp.prototype.z;
}
let SeAuthentication = class SeAuthentication {
    /**
     * @param {?} c
     * @param {?} r
     * @param {?} z
     */
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
};
SeAuthentication.ɵfac = function SeAuthentication_Factory(t) { return new (t || SeAuthentication)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
SeAuthentication.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: SeAuthentication, selectors: [["se-authentication"]], inputs: { appTitle: "appTitle", copyright: "copyright", domain: "domain", hide: "hide", imageUrl: "imageUrl", version: "version" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function SeAuthentication_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
SeAuthentication.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
/** @nocollapse */
SeAuthentication.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
SeAuthentication = __decorate([
    ProxyCmp({ inputs: ['appTitle', 'copyright', 'domain', 'hide', 'imageUrl', 'version'] }),
    __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])
], SeAuthentication);
if (false) {
    /**
     * @type {?}
     * @protected
     */
    SeAuthentication.prototype.el;
    /**
     * @type {?}
     * @protected
     */
    SeAuthentication.prototype.z;
}
let SeBanner = class SeBanner {
    /**
     * @param {?} c
     * @param {?} r
     * @param {?} z
     */
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
};
SeBanner.ɵfac = function SeBanner_Factory(t) { return new (t || SeBanner)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
SeBanner.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: SeBanner, selectors: [["se-banner"]], inputs: { duration: "duration" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function SeBanner_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
SeBanner.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
/** @nocollapse */
SeBanner.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
SeBanner = __decorate([
    ProxyCmp({ inputs: ['duration'] }),
    __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])
], SeBanner);
if (false) {
    /**
     * @type {?}
     * @protected
     */
    SeBanner.prototype.el;
    /**
     * @type {?}
     * @protected
     */
    SeBanner.prototype.z;
}
let SeBannerItem = class SeBannerItem {
    /**
     * @param {?} c
     * @param {?} r
     * @param {?} z
     */
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['didChange']);
    }
};
SeBannerItem.ɵfac = function SeBannerItem_Factory(t) { return new (t || SeBannerItem)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
SeBannerItem.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: SeBannerItem, selectors: [["se-banner-item"]], inputs: { active: "active", imageUrl: "imageUrl" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function SeBannerItem_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
SeBannerItem.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
/** @nocollapse */
SeBannerItem.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
SeBannerItem = __decorate([
    ProxyCmp({ inputs: ['active', 'imageUrl'] }),
    __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])
], SeBannerItem);
if (false) {
    /** @type {?} */
    SeBannerItem.prototype.didChange;
    /**
     * @type {?}
     * @protected
     */
    SeBannerItem.prototype.el;
    /**
     * @type {?}
     * @protected
     */
    SeBannerItem.prototype.z;
}
let SeBlock = class SeBlock {
    /**
     * @param {?} c
     * @param {?} r
     * @param {?} z
     */
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
};
SeBlock.ɵfac = function SeBlock_Factory(t) { return new (t || SeBlock)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
SeBlock.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: SeBlock, selectors: [["se-block"]], inputs: { clickable: "clickable", clickableBar: "clickableBar", color: "color", corner: "corner", display: "display", divider: "divider", enlarged: "enlarged", height: "height", loading: "loading", margin: "margin", option: "option", outline: "outline", outlineColor: "outlineColor", width: "width" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function SeBlock_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
SeBlock.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
/** @nocollapse */
SeBlock.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
SeBlock = __decorate([
    ProxyCmp({ inputs: ['clickable', 'clickableBar', 'color', 'corner', 'display', 'divider', 'enlarged', 'height', 'loading', 'margin', 'option', 'outline', 'outlineColor', 'width'] }),
    __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])
], SeBlock);
if (false) {
    /**
     * @type {?}
     * @protected
     */
    SeBlock.prototype.el;
    /**
     * @type {?}
     * @protected
     */
    SeBlock.prototype.z;
}
let SeBlockContent = class SeBlockContent {
    /**
     * @param {?} c
     * @param {?} r
     * @param {?} z
     */
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
};
SeBlockContent.ɵfac = function SeBlockContent_Factory(t) { return new (t || SeBlockContent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
SeBlockContent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: SeBlockContent, selectors: [["se-block-content"]], inputs: { option: "option" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function SeBlockContent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
SeBlockContent.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
/** @nocollapse */
SeBlockContent.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
SeBlockContent = __decorate([
    ProxyCmp({ inputs: ['option'] }),
    __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])
], SeBlockContent);
if (false) {
    /**
     * @type {?}
     * @protected
     */
    SeBlockContent.prototype.el;
    /**
     * @type {?}
     * @protected
     */
    SeBlockContent.prototype.z;
}
let SeBlockFooter = class SeBlockFooter {
    /**
     * @param {?} c
     * @param {?} r
     * @param {?} z
     */
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
};
SeBlockFooter.ɵfac = function SeBlockFooter_Factory(t) { return new (t || SeBlockFooter)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
SeBlockFooter.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: SeBlockFooter, selectors: [["se-block-footer"]], inputs: { direction: "direction", divider: "divider", option: "option" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function SeBlockFooter_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
SeBlockFooter.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
/** @nocollapse */
SeBlockFooter.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
SeBlockFooter = __decorate([
    ProxyCmp({ inputs: ['direction', 'divider', 'option'] }),
    __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])
], SeBlockFooter);
if (false) {
    /**
     * @type {?}
     * @protected
     */
    SeBlockFooter.prototype.el;
    /**
     * @type {?}
     * @protected
     */
    SeBlockFooter.prototype.z;
}
let SeBlockHeader = class SeBlockHeader {
    /**
     * @param {?} c
     * @param {?} r
     * @param {?} z
     */
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
};
SeBlockHeader.ɵfac = function SeBlockHeader_Factory(t) { return new (t || SeBlockHeader)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
SeBlockHeader.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: SeBlockHeader, selectors: [["se-block-header"]], inputs: { divider: "divider", option: "option" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function SeBlockHeader_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
SeBlockHeader.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
/** @nocollapse */
SeBlockHeader.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
SeBlockHeader = __decorate([
    ProxyCmp({ inputs: ['divider', 'option'] }),
    __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])
], SeBlockHeader);
if (false) {
    /**
     * @type {?}
     * @protected
     */
    SeBlockHeader.prototype.el;
    /**
     * @type {?}
     * @protected
     */
    SeBlockHeader.prototype.z;
}
let SeBreadcrumb = class SeBreadcrumb {
    /**
     * @param {?} c
     * @param {?} r
     * @param {?} z
     */
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
};
SeBreadcrumb.ɵfac = function SeBreadcrumb_Factory(t) { return new (t || SeBreadcrumb)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
SeBreadcrumb.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: SeBreadcrumb, selectors: [["se-breadcrumb"]], inputs: { canSelectLast: "canSelectLast" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function SeBreadcrumb_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
SeBreadcrumb.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
/** @nocollapse */
SeBreadcrumb.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
SeBreadcrumb = __decorate([
    ProxyCmp({ inputs: ['canSelectLast'] }),
    __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])
], SeBreadcrumb);
if (false) {
    /**
     * @type {?}
     * @protected
     */
    SeBreadcrumb.prototype.el;
    /**
     * @type {?}
     * @protected
     */
    SeBreadcrumb.prototype.z;
}
let SeBreadcrumbItem = class SeBreadcrumbItem {
    /**
     * @param {?} c
     * @param {?} r
     * @param {?} z
     */
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
};
SeBreadcrumbItem.ɵfac = function SeBreadcrumbItem_Factory(t) { return new (t || SeBreadcrumbItem)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
SeBreadcrumbItem.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: SeBreadcrumbItem, selectors: [["se-breadcrumb-item"]], inputs: { canSelect: "canSelect", href: "href", isLast: "isLast" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function SeBreadcrumbItem_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
SeBreadcrumbItem.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
/** @nocollapse */
SeBreadcrumbItem.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
SeBreadcrumbItem = __decorate([
    ProxyCmp({ inputs: ['canSelect', 'href', 'isLast'] }),
    __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])
], SeBreadcrumbItem);
if (false) {
    /**
     * @type {?}
     * @protected
     */
    SeBreadcrumbItem.prototype.el;
    /**
     * @type {?}
     * @protected
     */
    SeBreadcrumbItem.prototype.z;
}
let SeButton = class SeButton {
    /**
     * @param {?} c
     * @param {?} r
     * @param {?} z
     */
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['didClick']);
    }
};
SeButton.ɵfac = function SeButton_Factory(t) { return new (t || SeButton)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
SeButton.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: SeButton, selectors: [["se-button"]], inputs: { block: "block", caption: "caption", color: "color", disabled: "disabled", icon: "icon", iconColor: "iconColor", iconOnly: "iconOnly", option: "option", padding: "padding", selected: "selected", size: "size", type: "type", value: "value" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function SeButton_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
SeButton.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
/** @nocollapse */
SeButton.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
SeButton = __decorate([
    ProxyCmp({ inputs: ['block', 'caption', 'color', 'disabled', 'icon', 'iconColor', 'iconOnly', 'option', 'padding', 'selected', 'size', 'type', 'value'], 'methods': ['setDisabled', 'setGrouped'] }),
    __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])
], SeButton);
if (false) {
    /** @type {?} */
    SeButton.prototype.didClick;
    /**
     * @type {?}
     * @protected
     */
    SeButton.prototype.el;
    /**
     * @type {?}
     * @protected
     */
    SeButton.prototype.z;
}
let SeCheckbox = class SeCheckbox {
    /**
     * @param {?} c
     * @param {?} r
     * @param {?} z
     */
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['didChange']);
    }
};
SeCheckbox.ɵfac = function SeCheckbox_Factory(t) { return new (t || SeCheckbox)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
SeCheckbox.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: SeCheckbox, selectors: [["se-checkbox"]], inputs: { color: "color", disabled: "disabled", header: "header", label: "label", labelPos: "labelPos", option: "option", padding: "padding", required: "required", selected: "selected", textOff: "textOff", textOn: "textOn", value: "value" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function SeCheckbox_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
SeCheckbox.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
/** @nocollapse */
SeCheckbox.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
SeCheckbox = __decorate([
    ProxyCmp({ inputs: ['color', 'disabled', 'header', 'label', 'labelPos', 'option', 'padding', 'required', 'selected', 'textOff', 'textOn', 'value'], 'methods': ['setRequired'] }),
    __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])
], SeCheckbox);
if (false) {
    /** @type {?} */
    SeCheckbox.prototype.didChange;
    /**
     * @type {?}
     * @protected
     */
    SeCheckbox.prototype.el;
    /**
     * @type {?}
     * @protected
     */
    SeCheckbox.prototype.z;
}
let SeChip = class SeChip {
    /**
     * @param {?} c
     * @param {?} r
     * @param {?} z
     */
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['didClose']);
    }
};
SeChip.ɵfac = function SeChip_Factory(t) { return new (t || SeChip)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
SeChip.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: SeChip, selectors: [["se-chip"]], inputs: { block: "block", canClose: "canClose", color: "color", disabled: "disabled", selected: "selected", size: "size", value: "value" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function SeChip_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
SeChip.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
/** @nocollapse */
SeChip.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
SeChip = __decorate([
    ProxyCmp({ inputs: ['block', 'canClose', 'color', 'disabled', 'selected', 'size', 'value'] }),
    __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])
], SeChip);
if (false) {
    /** @type {?} */
    SeChip.prototype.didClose;
    /**
     * @type {?}
     * @protected
     */
    SeChip.prototype.el;
    /**
     * @type {?}
     * @protected
     */
    SeChip.prototype.z;
}
let SeContainer = class SeContainer {
    /**
     * @param {?} c
     * @param {?} r
     * @param {?} z
     */
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
};
SeContainer.ɵfac = function SeContainer_Factory(t) { return new (t || SeContainer)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
SeContainer.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: SeContainer, selectors: [["se-container"]], inputs: { color: "color", columnSize: "columnSize", direction: "direction", display: "display", option: "option", padding: "padding", position: "position", rowSize: "rowSize" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function SeContainer_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
SeContainer.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
/** @nocollapse */
SeContainer.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
SeContainer = __decorate([
    ProxyCmp({ inputs: ['color', 'columnSize', 'direction', 'display', 'option', 'padding', 'position', 'rowSize'] }),
    __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])
], SeContainer);
if (false) {
    /**
     * @type {?}
     * @protected
     */
    SeContainer.prototype.el;
    /**
     * @type {?}
     * @protected
     */
    SeContainer.prototype.z;
}
let SeDialog = class SeDialog {
    /**
     * @param {?} c
     * @param {?} r
     * @param {?} z
     */
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['backdrop', 'didClose']);
    }
};
SeDialog.ɵfac = function SeDialog_Factory(t) { return new (t || SeDialog)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
SeDialog.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: SeDialog, selectors: [["se-dialog"]], inputs: { canBackdrop: "canBackdrop", color: "color", open: "open", size: "size" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function SeDialog_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
SeDialog.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
/** @nocollapse */
SeDialog.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
SeDialog = __decorate([
    ProxyCmp({ inputs: ['canBackdrop', 'color', 'open', 'size'], 'methods': ['backdropClicked'] }),
    __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])
], SeDialog);
if (false) {
    /** @type {?} */
    SeDialog.prototype.backdrop;
    /** @type {?} */
    SeDialog.prototype.didClose;
    /**
     * @type {?}
     * @protected
     */
    SeDialog.prototype.el;
    /**
     * @type {?}
     * @protected
     */
    SeDialog.prototype.z;
}
let SeDialogContent = class SeDialogContent {
    /**
     * @param {?} c
     * @param {?} r
     * @param {?} z
     */
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
};
SeDialogContent.ɵfac = function SeDialogContent_Factory(t) { return new (t || SeDialogContent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
SeDialogContent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: SeDialogContent, selectors: [["se-dialog-content"]], inputs: { icon: "icon", iconColor: "iconColor", option: "option" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function SeDialogContent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
SeDialogContent.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
/** @nocollapse */
SeDialogContent.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
SeDialogContent = __decorate([
    ProxyCmp({ inputs: ['icon', 'iconColor', 'option'] }),
    __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])
], SeDialogContent);
if (false) {
    /**
     * @type {?}
     * @protected
     */
    SeDialogContent.prototype.el;
    /**
     * @type {?}
     * @protected
     */
    SeDialogContent.prototype.z;
}
class SeDialogFooter {
    /**
     * @param {?} c
     * @param {?} r
     * @param {?} z
     */
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
}
SeDialogFooter.ɵfac = function SeDialogFooter_Factory(t) { return new (t || SeDialogFooter)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
SeDialogFooter.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: SeDialogFooter, selectors: [["se-dialog-footer"]], ngContentSelectors: _c0, decls: 1, vars: 0, template: function SeDialogFooter_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
/** @nocollapse */
SeDialogFooter.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
if (false) {
    /**
     * @type {?}
     * @protected
     */
    SeDialogFooter.prototype.el;
    /**
     * @type {?}
     * @protected
     */
    SeDialogFooter.prototype.z;
}
let SeDialogHeader = class SeDialogHeader {
    /**
     * @param {?} c
     * @param {?} r
     * @param {?} z
     */
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
};
SeDialogHeader.ɵfac = function SeDialogHeader_Factory(t) { return new (t || SeDialogHeader)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
SeDialogHeader.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: SeDialogHeader, selectors: [["se-dialog-header"]], inputs: { color: "color" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function SeDialogHeader_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
SeDialogHeader.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
/** @nocollapse */
SeDialogHeader.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
SeDialogHeader = __decorate([
    ProxyCmp({ inputs: ['color'] }),
    __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])
], SeDialogHeader);
if (false) {
    /**
     * @type {?}
     * @protected
     */
    SeDialogHeader.prototype.el;
    /**
     * @type {?}
     * @protected
     */
    SeDialogHeader.prototype.z;
}
let SeDivider = class SeDivider {
    /**
     * @param {?} c
     * @param {?} r
     * @param {?} z
     */
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
};
SeDivider.ɵfac = function SeDivider_Factory(t) { return new (t || SeDivider)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
SeDivider.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: SeDivider, selectors: [["se-divider"]], inputs: { color: "color", option: "option" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function SeDivider_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
SeDivider.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
/** @nocollapse */
SeDivider.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
SeDivider = __decorate([
    ProxyCmp({ inputs: ['color', 'option'] }),
    __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])
], SeDivider);
if (false) {
    /**
     * @type {?}
     * @protected
     */
    SeDivider.prototype.el;
    /**
     * @type {?}
     * @protected
     */
    SeDivider.prototype.z;
}
let SeDropdown = class SeDropdown {
    /**
     * @param {?} c
     * @param {?} r
     * @param {?} z
     */
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['didOpen', 'didClose', 'cancelAllDropdown']);
    }
};
SeDropdown.ɵfac = function SeDropdown_Factory(t) { return new (t || SeDropdown)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
SeDropdown.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: SeDropdown, selectors: [["se-dropdown"]], inputs: { alignment: "alignment", maxHeight: "maxHeight", maxWidth: "maxWidth", verticalAlignment: "verticalAlignment" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function SeDropdown_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
SeDropdown.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
/** @nocollapse */
SeDropdown.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
SeDropdown = __decorate([
    ProxyCmp({ inputs: ['alignment', 'maxHeight', 'maxWidth', 'verticalAlignment'], 'methods': ['open', 'close'] }),
    __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])
], SeDropdown);
if (false) {
    /** @type {?} */
    SeDropdown.prototype.didOpen;
    /** @type {?} */
    SeDropdown.prototype.didClose;
    /** @type {?} */
    SeDropdown.prototype.cancelAllDropdown;
    /**
     * @type {?}
     * @protected
     */
    SeDropdown.prototype.el;
    /**
     * @type {?}
     * @protected
     */
    SeDropdown.prototype.z;
}
let SeFab = class SeFab {
    /**
     * @param {?} c
     * @param {?} r
     * @param {?} z
     */
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
};
SeFab.ɵfac = function SeFab_Factory(t) { return new (t || SeFab)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
SeFab.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: SeFab, selectors: [["se-fab"]], inputs: { color: "color", icon: "icon", option: "option", overlay: "overlay", position: "position" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function SeFab_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
SeFab.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
/** @nocollapse */
SeFab.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
SeFab = __decorate([
    ProxyCmp({ inputs: ['color', 'icon', 'option', 'overlay', 'position'], 'methods': ['toggleAction'] }),
    __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])
], SeFab);
if (false) {
    /**
     * @type {?}
     * @protected
     */
    SeFab.prototype.el;
    /**
     * @type {?}
     * @protected
     */
    SeFab.prototype.z;
}
let SeFabItem = class SeFabItem {
    /**
     * @param {?} c
     * @param {?} r
     * @param {?} z
     */
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['didClick']);
    }
};
SeFabItem.ɵfac = function SeFabItem_Factory(t) { return new (t || SeFabItem)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
SeFabItem.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: SeFabItem, selectors: [["se-fab-item"]], inputs: { icon: "icon" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function SeFabItem_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
SeFabItem.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
/** @nocollapse */
SeFabItem.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
SeFabItem = __decorate([
    ProxyCmp({ inputs: ['icon'] }),
    __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])
], SeFabItem);
if (false) {
    /** @type {?} */
    SeFabItem.prototype.didClick;
    /**
     * @type {?}
     * @protected
     */
    SeFabItem.prototype.el;
    /**
     * @type {?}
     * @protected
     */
    SeFabItem.prototype.z;
}
let SeFormField = class SeFormField {
    /**
     * @param {?} c
     * @param {?} r
     * @param {?} z
     */
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['didSubmit']);
    }
};
SeFormField.ɵfac = function SeFormField_Factory(t) { return new (t || SeFormField)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
SeFormField.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: SeFormField, selectors: [["se-form-field"]], inputs: { block: "block", disabled: "disabled", label: "label", labelWidth: "labelWidth", option: "option", padding: "padding", required: "required", status: "status", type: "type", value: "value" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function SeFormField_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
SeFormField.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
/** @nocollapse */
SeFormField.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
SeFormField = __decorate([
    ProxyCmp({ inputs: ['block', 'disabled', 'label', 'labelWidth', 'option', 'padding', 'required', 'status', 'type', 'value'] }),
    __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])
], SeFormField);
if (false) {
    /** @type {?} */
    SeFormField.prototype.didSubmit;
    /**
     * @type {?}
     * @protected
     */
    SeFormField.prototype.el;
    /**
     * @type {?}
     * @protected
     */
    SeFormField.prototype.z;
}
let SeHeader = class SeHeader {
    /**
     * @param {?} c
     * @param {?} r
     * @param {?} z
     */
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
};
SeHeader.ɵfac = function SeHeader_Factory(t) { return new (t || SeHeader)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
SeHeader.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: SeHeader, selectors: [["se-header"]], inputs: { appTitle: "appTitle", domain: "domain", project: "project" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function SeHeader_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
SeHeader.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
/** @nocollapse */
SeHeader.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
SeHeader = __decorate([
    ProxyCmp({ inputs: ['appTitle', 'domain', 'project'] }),
    __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])
], SeHeader);
if (false) {
    /**
     * @type {?}
     * @protected
     */
    SeHeader.prototype.el;
    /**
     * @type {?}
     * @protected
     */
    SeHeader.prototype.z;
}
let SeIcon = class SeIcon {
    /**
     * @param {?} c
     * @param {?} r
     * @param {?} z
     */
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
};
SeIcon.ɵfac = function SeIcon_Factory(t) { return new (t || SeIcon)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
SeIcon.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: SeIcon, selectors: [["se-icon"]], inputs: { color: "color", disabled: "disabled", option: "option", size: "size" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function SeIcon_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
SeIcon.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
/** @nocollapse */
SeIcon.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
SeIcon = __decorate([
    ProxyCmp({ inputs: ['color', 'disabled', 'option', 'size'] }),
    __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])
], SeIcon);
if (false) {
    /**
     * @type {?}
     * @protected
     */
    SeIcon.prototype.el;
    /**
     * @type {?}
     * @protected
     */
    SeIcon.prototype.z;
}
let SeIconEcostruxure = class SeIconEcostruxure {
    /**
     * @param {?} c
     * @param {?} r
     * @param {?} z
     */
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
};
SeIconEcostruxure.ɵfac = function SeIconEcostruxure_Factory(t) { return new (t || SeIconEcostruxure)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
SeIconEcostruxure.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: SeIconEcostruxure, selectors: [["se-icon-ecostruxure"]], inputs: { color: "color", size: "size" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function SeIconEcostruxure_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
SeIconEcostruxure.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
/** @nocollapse */
SeIconEcostruxure.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
SeIconEcostruxure = __decorate([
    ProxyCmp({ inputs: ['color', 'size'] }),
    __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])
], SeIconEcostruxure);
if (false) {
    /**
     * @type {?}
     * @protected
     */
    SeIconEcostruxure.prototype.el;
    /**
     * @type {?}
     * @protected
     */
    SeIconEcostruxure.prototype.z;
}
let SeIconLifeison = class SeIconLifeison {
    /**
     * @param {?} c
     * @param {?} r
     * @param {?} z
     */
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
};
SeIconLifeison.ɵfac = function SeIconLifeison_Factory(t) { return new (t || SeIconLifeison)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
SeIconLifeison.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: SeIconLifeison, selectors: [["se-icon-lifeison"]], inputs: { color: "color" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function SeIconLifeison_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
SeIconLifeison.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
/** @nocollapse */
SeIconLifeison.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
SeIconLifeison = __decorate([
    ProxyCmp({ inputs: ['color'] }),
    __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])
], SeIconLifeison);
if (false) {
    /**
     * @type {?}
     * @protected
     */
    SeIconLifeison.prototype.el;
    /**
     * @type {?}
     * @protected
     */
    SeIconLifeison.prototype.z;
}
class SeIconSchneider {
    /**
     * @param {?} c
     * @param {?} r
     * @param {?} z
     */
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
}
SeIconSchneider.ɵfac = function SeIconSchneider_Factory(t) { return new (t || SeIconSchneider)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
SeIconSchneider.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: SeIconSchneider, selectors: [["se-icon-schneider"]], ngContentSelectors: _c0, decls: 1, vars: 0, template: function SeIconSchneider_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
/** @nocollapse */
SeIconSchneider.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
if (false) {
    /**
     * @type {?}
     * @protected
     */
    SeIconSchneider.prototype.el;
    /**
     * @type {?}
     * @protected
     */
    SeIconSchneider.prototype.z;
}
let SeLink = class SeLink {
    /**
     * @param {?} c
     * @param {?} r
     * @param {?} z
     */
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
};
SeLink.ɵfac = function SeLink_Factory(t) { return new (t || SeLink)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
SeLink.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: SeLink, selectors: [["se-link"]], inputs: { disabled: "disabled", option: "option", url: "url" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function SeLink_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
SeLink.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
/** @nocollapse */
SeLink.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
SeLink = __decorate([
    ProxyCmp({ inputs: ['disabled', 'option', 'url'] }),
    __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])
], SeLink);
if (false) {
    /**
     * @type {?}
     * @protected
     */
    SeLink.prototype.el;
    /**
     * @type {?}
     * @protected
     */
    SeLink.prototype.z;
}
let SeList = class SeList {
    /**
     * @param {?} c
     * @param {?} r
     * @param {?} z
     */
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
};
SeList.ɵfac = function SeList_Factory(t) { return new (t || SeList)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
SeList.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: SeList, selectors: [["se-list"]], inputs: { canCollapse: "canCollapse", option: "option" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function SeList_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
SeList.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
/** @nocollapse */
SeList.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
SeList = __decorate([
    ProxyCmp({ inputs: ['canCollapse', 'option'] }),
    __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])
], SeList);
if (false) {
    /**
     * @type {?}
     * @protected
     */
    SeList.prototype.el;
    /**
     * @type {?}
     * @protected
     */
    SeList.prototype.z;
}
let SeListGroup = class SeListGroup {
    /**
     * @param {?} c
     * @param {?} r
     * @param {?} z
     */
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['didGroupClick', 'didGroupCollapse']);
    }
};
SeListGroup.ɵfac = function SeListGroup_Factory(t) { return new (t || SeListGroup)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
SeListGroup.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: SeListGroup, selectors: [["se-list-group"]], inputs: { canCollapse: "canCollapse", collapsed: "collapsed", description: "description", icon: "icon", iconColor: "iconColor", indentation: "indentation", item: "item", option: "option", selected: "selected", selectedChild: "selectedChild" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function SeListGroup_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
SeListGroup.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
/** @nocollapse */
SeListGroup.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
SeListGroup = __decorate([
    ProxyCmp({ inputs: ['canCollapse', 'collapsed', 'description', 'icon', 'iconColor', 'indentation', 'item', 'option', 'selected', 'selectedChild'], 'methods': ['toggleCollapseTreeview', 'focusElement'] }),
    __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])
], SeListGroup);
if (false) {
    /** @type {?} */
    SeListGroup.prototype.didGroupClick;
    /** @type {?} */
    SeListGroup.prototype.didGroupCollapse;
    /**
     * @type {?}
     * @protected
     */
    SeListGroup.prototype.el;
    /**
     * @type {?}
     * @protected
     */
    SeListGroup.prototype.z;
}
let SeListItem = class SeListItem {
    /**
     * @param {?} c
     * @param {?} r
     * @param {?} z
     */
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['didSelectedChange']);
    }
};
SeListItem.ɵfac = function SeListItem_Factory(t) { return new (t || SeListItem)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
SeListItem.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: SeListItem, selectors: [["se-list-item"]], inputs: { description: "description", href: "href", icon: "icon", iconColor: "iconColor", indentation: "indentation", item: "item", option: "option", selected: "selected" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function SeListItem_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
SeListItem.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
/** @nocollapse */
SeListItem.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
SeListItem = __decorate([
    ProxyCmp({ inputs: ['description', 'href', 'icon', 'iconColor', 'indentation', 'item', 'option', 'selected'], 'methods': ['focusElement'] }),
    __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])
], SeListItem);
if (false) {
    /** @type {?} */
    SeListItem.prototype.didSelectedChange;
    /**
     * @type {?}
     * @protected
     */
    SeListItem.prototype.el;
    /**
     * @type {?}
     * @protected
     */
    SeListItem.prototype.z;
}
let SeLoading = class SeLoading {
    /**
     * @param {?} c
     * @param {?} r
     * @param {?} z
     */
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
};
SeLoading.ɵfac = function SeLoading_Factory(t) { return new (t || SeLoading)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
SeLoading.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: SeLoading, selectors: [["se-loading"]], inputs: { color: "color", fullPage: "fullPage", loading: "loading", option: "option" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function SeLoading_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
SeLoading.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
/** @nocollapse */
SeLoading.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
SeLoading = __decorate([
    ProxyCmp({ inputs: ['color', 'fullPage', 'loading', 'option'] }),
    __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])
], SeLoading);
if (false) {
    /**
     * @type {?}
     * @protected
     */
    SeLoading.prototype.el;
    /**
     * @type {?}
     * @protected
     */
    SeLoading.prototype.z;
}
let SeRadio = class SeRadio {
    /**
     * @param {?} c
     * @param {?} r
     * @param {?} z
     */
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['didCheck']);
    }
};
SeRadio.ɵfac = function SeRadio_Factory(t) { return new (t || SeRadio)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
SeRadio.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: SeRadio, selectors: [["se-radio"]], inputs: { color: "color", disabled: "disabled", label: "label", labelPos: "labelPos", padding: "padding", required: "required", selected: "selected", value: "value" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function SeRadio_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
SeRadio.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
/** @nocollapse */
SeRadio.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
SeRadio = __decorate([
    ProxyCmp({ inputs: ['color', 'disabled', 'label', 'labelPos', 'padding', 'required', 'selected', 'value'], 'methods': ['setRequired'] }),
    __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])
], SeRadio);
if (false) {
    /** @type {?} */
    SeRadio.prototype.didCheck;
    /**
     * @type {?}
     * @protected
     */
    SeRadio.prototype.el;
    /**
     * @type {?}
     * @protected
     */
    SeRadio.prototype.z;
}
let SeRadioGroup = class SeRadioGroup {
    /**
     * @param {?} c
     * @param {?} r
     * @param {?} z
     */
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['didChange']);
    }
};
SeRadioGroup.ɵfac = function SeRadioGroup_Factory(t) { return new (t || SeRadioGroup)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
SeRadioGroup.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: SeRadioGroup, selectors: [["se-radio-group"]], inputs: { color: "color", direction: "direction", disabled: "disabled", size: "size", value: "value" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function SeRadioGroup_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
SeRadioGroup.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
/** @nocollapse */
SeRadioGroup.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
SeRadioGroup = __decorate([
    ProxyCmp({ inputs: ['color', 'direction', 'disabled', 'size', 'value'] }),
    __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])
], SeRadioGroup);
if (false) {
    /** @type {?} */
    SeRadioGroup.prototype.didChange;
    /**
     * @type {?}
     * @protected
     */
    SeRadioGroup.prototype.el;
    /**
     * @type {?}
     * @protected
     */
    SeRadioGroup.prototype.z;
}
let SeSidemenu = class SeSidemenu {
    /**
     * @param {?} c
     * @param {?} r
     * @param {?} z
     */
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['toggled']);
    }
};
SeSidemenu.ɵfac = function SeSidemenu_Factory(t) { return new (t || SeSidemenu)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
SeSidemenu.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: SeSidemenu, selectors: [["se-sidemenu"]], inputs: { label: "label", link: "link" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function SeSidemenu_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
SeSidemenu.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
/** @nocollapse */
SeSidemenu.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
SeSidemenu = __decorate([
    ProxyCmp({ inputs: ['label', 'link'], 'methods': ['toggle'] }),
    __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])
], SeSidemenu);
if (false) {
    /** @type {?} */
    SeSidemenu.prototype.toggled;
    /**
     * @type {?}
     * @protected
     */
    SeSidemenu.prototype.el;
    /**
     * @type {?}
     * @protected
     */
    SeSidemenu.prototype.z;
}
let SeSidemenuItem = class SeSidemenuItem {
    /**
     * @param {?} c
     * @param {?} r
     * @param {?} z
     */
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['didClick']);
    }
};
SeSidemenuItem.ɵfac = function SeSidemenuItem_Factory(t) { return new (t || SeSidemenuItem)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
SeSidemenuItem.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: SeSidemenuItem, selectors: [["se-sidemenu-item"]], inputs: { active: "active", item: "item" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function SeSidemenuItem_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
SeSidemenuItem.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
/** @nocollapse */
SeSidemenuItem.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
SeSidemenuItem = __decorate([
    ProxyCmp({ inputs: ['active', 'item'] }),
    __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])
], SeSidemenuItem);
if (false) {
    /** @type {?} */
    SeSidemenuItem.prototype.didClick;
    /**
     * @type {?}
     * @protected
     */
    SeSidemenuItem.prototype.el;
    /**
     * @type {?}
     * @protected
     */
    SeSidemenuItem.prototype.z;
}
let SeSlider = class SeSlider {
    /**
     * @param {?} c
     * @param {?} r
     * @param {?} z
     */
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['didChange']);
    }
};
SeSlider.ɵfac = function SeSlider_Factory(t) { return new (t || SeSlider)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
SeSlider.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: SeSlider, selectors: [["se-slider"]], inputs: { disabled: "disabled", label: "label", max: "max", min: "min", value: "value" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function SeSlider_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
SeSlider.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
/** @nocollapse */
SeSlider.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
SeSlider = __decorate([
    ProxyCmp({ inputs: ['disabled', 'label', 'max', 'min', 'value'], 'methods': ['setDisabled'] }),
    __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])
], SeSlider);
if (false) {
    /** @type {?} */
    SeSlider.prototype.didChange;
    /**
     * @type {?}
     * @protected
     */
    SeSlider.prototype.el;
    /**
     * @type {?}
     * @protected
     */
    SeSlider.prototype.z;
}
let SeSnackbar = class SeSnackbar {
    /**
     * @param {?} c
     * @param {?} r
     * @param {?} z
     */
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['didClose', 'actionClicked']);
    }
};
SeSnackbar.ɵfac = function SeSnackbar_Factory(t) { return new (t || SeSnackbar)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
SeSnackbar.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: SeSnackbar, selectors: [["se-snackbar"]], inputs: { actionText: "actionText", canClose: "canClose", duration: "duration", icon: "icon", message: "message", open: "open", type: "type" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function SeSnackbar_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
SeSnackbar.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
/** @nocollapse */
SeSnackbar.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
SeSnackbar = __decorate([
    ProxyCmp({ inputs: ['actionText', 'canClose', 'duration', 'icon', 'message', 'open', 'type'] }),
    __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])
], SeSnackbar);
if (false) {
    /** @type {?} */
    SeSnackbar.prototype.didClose;
    /** @type {?} */
    SeSnackbar.prototype.actionClicked;
    /**
     * @type {?}
     * @protected
     */
    SeSnackbar.prototype.el;
    /**
     * @type {?}
     * @protected
     */
    SeSnackbar.prototype.z;
}
let SeStepper = class SeStepper {
    /**
     * @param {?} c
     * @param {?} r
     * @param {?} z
     */
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
};
SeStepper.ɵfac = function SeStepper_Factory(t) { return new (t || SeStepper)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
SeStepper.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: SeStepper, selectors: [["se-stepper"]], inputs: { block: "block", color: "color", interactive: "interactive", linear: "linear" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function SeStepper_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
SeStepper.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
/** @nocollapse */
SeStepper.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
SeStepper = __decorate([
    ProxyCmp({ inputs: ['block', 'color', 'interactive', 'linear'], 'methods': ['reset', 'previous', 'next'] }),
    __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])
], SeStepper);
if (false) {
    /**
     * @type {?}
     * @protected
     */
    SeStepper.prototype.el;
    /**
     * @type {?}
     * @protected
     */
    SeStepper.prototype.z;
}
let SeStepperItem = class SeStepperItem {
    /**
     * @param {?} c
     * @param {?} r
     * @param {?} z
     */
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['didValidate']);
    }
};
SeStepperItem.ɵfac = function SeStepperItem_Factory(t) { return new (t || SeStepperItem)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
SeStepperItem.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: SeStepperItem, selectors: [["se-stepper-item"]], inputs: { active: "active", interactive: "interactive", label: "label", validated: "validated" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function SeStepperItem_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
SeStepperItem.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
/** @nocollapse */
SeStepperItem.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
SeStepperItem = __decorate([
    ProxyCmp({ inputs: ['active', 'interactive', 'label', 'validated'] }),
    __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])
], SeStepperItem);
if (false) {
    /** @type {?} */
    SeStepperItem.prototype.didValidate;
    /**
     * @type {?}
     * @protected
     */
    SeStepperItem.prototype.el;
    /**
     * @type {?}
     * @protected
     */
    SeStepperItem.prototype.z;
}
let SeTabbar = class SeTabbar {
    /**
     * @param {?} c
     * @param {?} r
     * @param {?} z
     */
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
};
SeTabbar.ɵfac = function SeTabbar_Factory(t) { return new (t || SeTabbar)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
SeTabbar.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: SeTabbar, selectors: [["se-tabbar"]], inputs: { color: "color", option: "option", overflow: "overflow" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function SeTabbar_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
SeTabbar.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
/** @nocollapse */
SeTabbar.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
SeTabbar = __decorate([
    ProxyCmp({ inputs: ['color', 'option', 'overflow'] }),
    __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])
], SeTabbar);
if (false) {
    /**
     * @type {?}
     * @protected
     */
    SeTabbar.prototype.el;
    /**
     * @type {?}
     * @protected
     */
    SeTabbar.prototype.z;
}
class SeTable {
    /**
     * @param {?} c
     * @param {?} r
     * @param {?} z
     */
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
}
SeTable.ɵfac = function SeTable_Factory(t) { return new (t || SeTable)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
SeTable.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: SeTable, selectors: [["se-table"]], ngContentSelectors: _c0, decls: 1, vars: 0, template: function SeTable_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
/** @nocollapse */
SeTable.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
if (false) {
    /**
     * @type {?}
     * @protected
     */
    SeTable.prototype.el;
    /**
     * @type {?}
     * @protected
     */
    SeTable.prototype.z;
}
let SeTableGroup = class SeTableGroup {
    /**
     * @param {?} c
     * @param {?} r
     * @param {?} z
     */
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
};
SeTableGroup.ɵfac = function SeTableGroup_Factory(t) { return new (t || SeTableGroup)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
SeTableGroup.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: SeTableGroup, selectors: [["se-table-group"]], inputs: { selectable: "selectable", selected: "selected" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function SeTableGroup_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
SeTableGroup.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
/** @nocollapse */
SeTableGroup.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
SeTableGroup = __decorate([
    ProxyCmp({ inputs: ['selectable', 'selected'] }),
    __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])
], SeTableGroup);
if (false) {
    /**
     * @type {?}
     * @protected
     */
    SeTableGroup.prototype.el;
    /**
     * @type {?}
     * @protected
     */
    SeTableGroup.prototype.z;
}
class SeTableGroupHeader {
    /**
     * @param {?} c
     * @param {?} r
     * @param {?} z
     */
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
}
SeTableGroupHeader.ɵfac = function SeTableGroupHeader_Factory(t) { return new (t || SeTableGroupHeader)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
SeTableGroupHeader.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: SeTableGroupHeader, selectors: [["se-table-group-header"]], ngContentSelectors: _c0, decls: 1, vars: 0, template: function SeTableGroupHeader_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
/** @nocollapse */
SeTableGroupHeader.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
if (false) {
    /**
     * @type {?}
     * @protected
     */
    SeTableGroupHeader.prototype.el;
    /**
     * @type {?}
     * @protected
     */
    SeTableGroupHeader.prototype.z;
}
let SeTableItem = class SeTableItem {
    /**
     * @param {?} c
     * @param {?} r
     * @param {?} z
     */
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
};
SeTableItem.ɵfac = function SeTableItem_Factory(t) { return new (t || SeTableItem)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
SeTableItem.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: SeTableItem, selectors: [["se-table-item"]], inputs: { clickable: "clickable", flex: "flex", minWidth: "minWidth", option: "option", width: "width" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function SeTableItem_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
SeTableItem.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
/** @nocollapse */
SeTableItem.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
SeTableItem = __decorate([
    ProxyCmp({ inputs: ['clickable', 'flex', 'minWidth', 'option', 'width'] }),
    __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])
], SeTableItem);
if (false) {
    /**
     * @type {?}
     * @protected
     */
    SeTableItem.prototype.el;
    /**
     * @type {?}
     * @protected
     */
    SeTableItem.prototype.z;
}
let SeTableItemHeader = class SeTableItemHeader {
    /**
     * @param {?} c
     * @param {?} r
     * @param {?} z
     */
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
};
SeTableItemHeader.ɵfac = function SeTableItemHeader_Factory(t) { return new (t || SeTableItemHeader)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
SeTableItemHeader.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: SeTableItemHeader, selectors: [["se-table-item-header"]], inputs: { clickable: "clickable", flex: "flex", minWidth: "minWidth", sort: "sort", width: "width" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function SeTableItemHeader_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
SeTableItemHeader.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
/** @nocollapse */
SeTableItemHeader.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
SeTableItemHeader = __decorate([
    ProxyCmp({ inputs: ['clickable', 'flex', 'minWidth', 'sort', 'width'] }),
    __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])
], SeTableItemHeader);
if (false) {
    /**
     * @type {?}
     * @protected
     */
    SeTableItemHeader.prototype.el;
    /**
     * @type {?}
     * @protected
     */
    SeTableItemHeader.prototype.z;
}
let SeTooltip = class SeTooltip {
    /**
     * @param {?} c
     * @param {?} r
     * @param {?} z
     */
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['didOpen', 'didClose', 'closeTooltips']);
    }
};
SeTooltip.ɵfac = function SeTooltip_Factory(t) { return new (t || SeTooltip)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
SeTooltip.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: SeTooltip, selectors: [["se-tooltip"]], inputs: { action: "action", position: "position" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function SeTooltip_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
SeTooltip.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
/** @nocollapse */
SeTooltip.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
SeTooltip = __decorate([
    ProxyCmp({ inputs: ['action', 'position'], 'methods': ['open', 'close'] }),
    __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])
], SeTooltip);
if (false) {
    /** @type {?} */
    SeTooltip.prototype.didOpen;
    /** @type {?} */
    SeTooltip.prototype.didClose;
    /** @type {?} */
    SeTooltip.prototype.closeTooltips;
    /**
     * @type {?}
     * @protected
     */
    SeTooltip.prototype.el;
    /**
     * @type {?}
     * @protected
     */
    SeTooltip.prototype.z;
}
let SeTooltipContent = class SeTooltipContent {
    /**
     * @param {?} c
     * @param {?} r
     * @param {?} z
     */
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
};
SeTooltipContent.ɵfac = function SeTooltipContent_Factory(t) { return new (t || SeTooltipContent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
SeTooltipContent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: SeTooltipContent, selectors: [["se-tooltip-content"]], inputs: { icon: "icon" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function SeTooltipContent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
SeTooltipContent.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
/** @nocollapse */
SeTooltipContent.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
SeTooltipContent = __decorate([
    ProxyCmp({ inputs: ['icon'] }),
    __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])
], SeTooltipContent);
if (false) {
    /**
     * @type {?}
     * @protected
     */
    SeTooltipContent.prototype.el;
    /**
     * @type {?}
     * @protected
     */
    SeTooltipContent.prototype.z;
}
class SeTooltipFooter {
    /**
     * @param {?} c
     * @param {?} r
     * @param {?} z
     */
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
}
SeTooltipFooter.ɵfac = function SeTooltipFooter_Factory(t) { return new (t || SeTooltipFooter)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
SeTooltipFooter.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: SeTooltipFooter, selectors: [["se-tooltip-footer"]], ngContentSelectors: _c0, decls: 1, vars: 0, template: function SeTooltipFooter_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
/** @nocollapse */
SeTooltipFooter.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
if (false) {
    /**
     * @type {?}
     * @protected
     */
    SeTooltipFooter.prototype.el;
    /**
     * @type {?}
     * @protected
     */
    SeTooltipFooter.prototype.z;
}
let SeTooltipHeader = class SeTooltipHeader {
    /**
     * @param {?} c
     * @param {?} r
     * @param {?} z
     */
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
};
SeTooltipHeader.ɵfac = function SeTooltipHeader_Factory(t) { return new (t || SeTooltipHeader)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
SeTooltipHeader.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: SeTooltipHeader, selectors: [["se-tooltip-header"]], inputs: { icon: "icon" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function SeTooltipHeader_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
SeTooltipHeader.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
/** @nocollapse */
SeTooltipHeader.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
SeTooltipHeader = __decorate([
    ProxyCmp({ inputs: ['icon'] }),
    __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])
], SeTooltipHeader);
if (false) {
    /**
     * @type {?}
     * @protected
     */
    SeTooltipHeader.prototype.el;
    /**
     * @type {?}
     * @protected
     */
    SeTooltipHeader.prototype.z;
}
let SeVisualLinear = class SeVisualLinear {
    /**
     * @param {?} c
     * @param {?} r
     * @param {?} z
     */
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
};
SeVisualLinear.ɵfac = function SeVisualLinear_Factory(t) { return new (t || SeVisualLinear)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
SeVisualLinear.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: SeVisualLinear, selectors: [["se-visual-linear"]], inputs: { label: "label", option: "option", percentage: "percentage", secolor: "secolor", value: "value" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function SeVisualLinear_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
SeVisualLinear.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
/** @nocollapse */
SeVisualLinear.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
SeVisualLinear = __decorate([
    ProxyCmp({ inputs: ['label', 'option', 'percentage', 'secolor', 'value'] }),
    __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])
], SeVisualLinear);
if (false) {
    /**
     * @type {?}
     * @protected
     */
    SeVisualLinear.prototype.el;
    /**
     * @type {?}
     * @protected
     */
    SeVisualLinear.prototype.z;
}
let SeVisualRadial = class SeVisualRadial {
    /**
     * @param {?} c
     * @param {?} r
     * @param {?} z
     */
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
};
SeVisualRadial.ɵfac = function SeVisualRadial_Factory(t) { return new (t || SeVisualRadial)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
SeVisualRadial.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: SeVisualRadial, selectors: [["se-visual-radial"]], inputs: { label: "label", percentage: "percentage", secolor: "secolor", size: "size", value: "value" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function SeVisualRadial_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
SeVisualRadial.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
/** @nocollapse */
SeVisualRadial.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
SeVisualRadial = __decorate([
    ProxyCmp({ inputs: ['label', 'percentage', 'secolor', 'size', 'value'] }),
    __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])
], SeVisualRadial);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SnackbarComponent, [{
        type: Component,
        args: [{ selector: 'se-ng-snackbar', template: "\n<se-snackbar  \n[open]=\"true\"\n[type]=\"config.type\" \n[icon]=\"config.icon\" \n[message]=\"config.message\" \n[canClose]=\"config.canClose\" \n[actionText]=\"config.actionText\"\n[duration]=\"config.duration\"\n(didClose)=\"closeEvent()\"\n(actionClicked)=\"actionClickedEvent()\">\n</se-snackbar>\n", styles: [":host{display:flex;flex-direction:column}"] }]
    }], function () { return [{ type: SnackbarConfig }]; }, { didClose: [{
            type: Output
        }], actionClicked: [{
            type: Output
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SnackbarService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc0.ComponentFactoryResolver }, { type: ɵngcc0.ApplicationRef }, { type: ɵngcc0.Injector }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SeAbout, [{
        type: Component,
        args: [{ selector: 'se-about', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>', inputs: ['appTitle', 'copyright', 'domain', 'imageUrl', 'version'] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SeApp, [{
        type: Component,
        args: [{ selector: 'se-app', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>', inputs: ['option', 'theme'] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SeAuthentication, [{
        type: Component,
        args: [{ selector: 'se-authentication', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>', inputs: ['appTitle', 'copyright', 'domain', 'hide', 'imageUrl', 'version'] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SeBanner, [{
        type: Component,
        args: [{ selector: 'se-banner', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>', inputs: ['duration'] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SeBannerItem, [{
        type: Component,
        args: [{ selector: 'se-banner-item', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>', inputs: ['active', 'imageUrl'] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SeBlock, [{
        type: Component,
        args: [{ selector: 'se-block', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>', inputs: ['clickable', 'clickableBar', 'color', 'corner', 'display', 'divider', 'enlarged', 'height', 'loading', 'margin', 'option', 'outline', 'outlineColor', 'width'] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SeBlockContent, [{
        type: Component,
        args: [{ selector: 'se-block-content', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>', inputs: ['option'] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SeBlockFooter, [{
        type: Component,
        args: [{ selector: 'se-block-footer', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>', inputs: ['direction', 'divider', 'option'] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SeBlockHeader, [{
        type: Component,
        args: [{ selector: 'se-block-header', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>', inputs: ['divider', 'option'] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SeBreadcrumb, [{
        type: Component,
        args: [{ selector: 'se-breadcrumb', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>', inputs: ['canSelectLast'] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SeBreadcrumbItem, [{
        type: Component,
        args: [{ selector: 'se-breadcrumb-item', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>', inputs: ['canSelect', 'href', 'isLast'] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SeButton, [{
        type: Component,
        args: [{ selector: 'se-button', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>', inputs: ['block', 'caption', 'color', 'disabled', 'icon', 'iconColor', 'iconOnly', 'option', 'padding', 'selected', 'size', 'type', 'value'] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SeCheckbox, [{
        type: Component,
        args: [{ selector: 'se-checkbox', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>', inputs: ['color', 'disabled', 'header', 'label', 'labelPos', 'option', 'padding', 'required', 'selected', 'textOff', 'textOn', 'value'] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SeChip, [{
        type: Component,
        args: [{ selector: 'se-chip', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>', inputs: ['block', 'canClose', 'color', 'disabled', 'selected', 'size', 'value'] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SeContainer, [{
        type: Component,
        args: [{ selector: 'se-container', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>', inputs: ['color', 'columnSize', 'direction', 'display', 'option', 'padding', 'position', 'rowSize'] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SeDialog, [{
        type: Component,
        args: [{ selector: 'se-dialog', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>', inputs: ['canBackdrop', 'color', 'open', 'size'] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SeDialogContent, [{
        type: Component,
        args: [{ selector: 'se-dialog-content', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>', inputs: ['icon', 'iconColor', 'option'] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SeDialogFooter, [{
        type: Component,
        args: [{ selector: 'se-dialog-footer', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>' }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SeDialogHeader, [{
        type: Component,
        args: [{ selector: 'se-dialog-header', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>', inputs: ['color'] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SeDivider, [{
        type: Component,
        args: [{ selector: 'se-divider', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>', inputs: ['color', 'option'] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SeDropdown, [{
        type: Component,
        args: [{ selector: 'se-dropdown', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>', inputs: ['alignment', 'maxHeight', 'maxWidth', 'verticalAlignment'] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SeFab, [{
        type: Component,
        args: [{ selector: 'se-fab', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>', inputs: ['color', 'icon', 'option', 'overlay', 'position'] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SeFabItem, [{
        type: Component,
        args: [{ selector: 'se-fab-item', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>', inputs: ['icon'] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SeFormField, [{
        type: Component,
        args: [{ selector: 'se-form-field', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>', inputs: ['block', 'disabled', 'label', 'labelWidth', 'option', 'padding', 'required', 'status', 'type', 'value'] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SeHeader, [{
        type: Component,
        args: [{ selector: 'se-header', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>', inputs: ['appTitle', 'domain', 'project'] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SeIcon, [{
        type: Component,
        args: [{ selector: 'se-icon', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>', inputs: ['color', 'disabled', 'option', 'size'] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SeIconEcostruxure, [{
        type: Component,
        args: [{ selector: 'se-icon-ecostruxure', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>', inputs: ['color', 'size'] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SeIconLifeison, [{
        type: Component,
        args: [{ selector: 'se-icon-lifeison', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>', inputs: ['color'] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SeIconSchneider, [{
        type: Component,
        args: [{ selector: 'se-icon-schneider', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>' }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SeLink, [{
        type: Component,
        args: [{ selector: 'se-link', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>', inputs: ['disabled', 'option', 'url'] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SeList, [{
        type: Component,
        args: [{ selector: 'se-list', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>', inputs: ['canCollapse', 'option'] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SeListGroup, [{
        type: Component,
        args: [{ selector: 'se-list-group', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>', inputs: ['canCollapse', 'collapsed', 'description', 'icon', 'iconColor', 'indentation', 'item', 'option', 'selected', 'selectedChild'] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SeListItem, [{
        type: Component,
        args: [{ selector: 'se-list-item', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>', inputs: ['description', 'href', 'icon', 'iconColor', 'indentation', 'item', 'option', 'selected'] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SeLoading, [{
        type: Component,
        args: [{ selector: 'se-loading', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>', inputs: ['color', 'fullPage', 'loading', 'option'] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SeRadio, [{
        type: Component,
        args: [{ selector: 'se-radio', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>', inputs: ['color', 'disabled', 'label', 'labelPos', 'padding', 'required', 'selected', 'value'] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SeRadioGroup, [{
        type: Component,
        args: [{ selector: 'se-radio-group', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>', inputs: ['color', 'direction', 'disabled', 'size', 'value'] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SeSidemenu, [{
        type: Component,
        args: [{ selector: 'se-sidemenu', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>', inputs: ['label', 'link'] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SeSidemenuItem, [{
        type: Component,
        args: [{ selector: 'se-sidemenu-item', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>', inputs: ['active', 'item'] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SeSlider, [{
        type: Component,
        args: [{ selector: 'se-slider', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>', inputs: ['disabled', 'label', 'max', 'min', 'value'] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SeSnackbar, [{
        type: Component,
        args: [{ selector: 'se-snackbar', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>', inputs: ['actionText', 'canClose', 'duration', 'icon', 'message', 'open', 'type'] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SeStepper, [{
        type: Component,
        args: [{ selector: 'se-stepper', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>', inputs: ['block', 'color', 'interactive', 'linear'] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SeStepperItem, [{
        type: Component,
        args: [{ selector: 'se-stepper-item', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>', inputs: ['active', 'interactive', 'label', 'validated'] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SeTabbar, [{
        type: Component,
        args: [{ selector: 'se-tabbar', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>', inputs: ['color', 'option', 'overflow'] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SeTable, [{
        type: Component,
        args: [{ selector: 'se-table', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>' }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SeTableGroup, [{
        type: Component,
        args: [{ selector: 'se-table-group', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>', inputs: ['selectable', 'selected'] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SeTableGroupHeader, [{
        type: Component,
        args: [{ selector: 'se-table-group-header', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>' }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SeTableItem, [{
        type: Component,
        args: [{ selector: 'se-table-item', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>', inputs: ['clickable', 'flex', 'minWidth', 'option', 'width'] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SeTableItemHeader, [{
        type: Component,
        args: [{ selector: 'se-table-item-header', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>', inputs: ['clickable', 'flex', 'minWidth', 'sort', 'width'] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SeTooltip, [{
        type: Component,
        args: [{ selector: 'se-tooltip', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>', inputs: ['action', 'position'] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SeTooltipContent, [{
        type: Component,
        args: [{ selector: 'se-tooltip-content', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>', inputs: ['icon'] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SeTooltipFooter, [{
        type: Component,
        args: [{ selector: 'se-tooltip-footer', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>' }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SeTooltipHeader, [{
        type: Component,
        args: [{ selector: 'se-tooltip-header', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>', inputs: ['icon'] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SeVisualLinear, [{
        type: Component,
        args: [{ selector: 'se-visual-linear', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>', inputs: ['label', 'option', 'percentage', 'secolor', 'value'] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SeVisualRadial, [{
        type: Component,
        args: [{ selector: 'se-visual-radial', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>', inputs: ['label', 'percentage', 'secolor', 'size', 'value'] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
if (false) {
    /**
     * @type {?}
     * @protected
     */
    SeVisualRadial.prototype.el;
    /**
     * @type {?}
     * @protected
     */
    SeVisualRadial.prototype.z;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/directives/proxies-list.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const DIRECTIVES = [
    SeAbout,
    SeApp,
    SeAuthentication,
    SeBanner,
    SeBannerItem,
    SeBlock,
    SeBlockContent,
    SeBlockFooter,
    SeBlockHeader,
    SeBreadcrumb,
    SeBreadcrumbItem,
    SeButton,
    SeCheckbox,
    SeChip,
    SeContainer,
    SeDialog,
    SeDialogContent,
    SeDialogFooter,
    SeDialogHeader,
    SeDivider,
    SeDropdown,
    SeFab,
    SeFabItem,
    SeFormField,
    SeHeader,
    SeIcon,
    SeIconEcostruxure,
    SeIconLifeison,
    SeIconSchneider,
    SeLink,
    SeList,
    SeListGroup,
    SeListItem,
    SeLoading,
    SeRadio,
    SeRadioGroup,
    SeSidemenu,
    SeSidemenuItem,
    SeSlider,
    SeSnackbar,
    SeStepper,
    SeStepperItem,
    SeTabbar,
    SeTable,
    SeTableGroup,
    SeTableGroupHeader,
    SeTableItem,
    SeTableItemHeader,
    SeTooltip,
    SeTooltipContent,
    SeTooltipFooter,
    SeTooltipHeader,
    SeVisualLinear,
    SeVisualRadial
];

/**
 * @fileoverview added by tsickle
 * Generated from: lib/directives/proxies.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ProxiesModule {
}
ProxiesModule.ɵfac = function ProxiesModule_Factory(t) { return new (t || ProxiesModule)(); };
ProxiesModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: ProxiesModule });
ProxiesModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [CommonModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ProxiesModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule
                ],
                declarations: DIRECTIVES,
                exports: DIRECTIVES
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(ProxiesModule, { declarations: function () { return [SeAbout, SeApp, SeAuthentication, SeBanner, SeBannerItem, SeBlock, SeBlockContent, SeBlockFooter, SeBlockHeader, SeBreadcrumb, SeBreadcrumbItem, SeButton, SeCheckbox, SeChip, SeContainer, SeDialog, SeDialogContent, SeDialogFooter, SeDialogHeader, SeDivider, SeDropdown, SeFab, SeFabItem, SeFormField, SeHeader, SeIcon, SeIconEcostruxure, SeIconLifeison, SeIconSchneider, SeLink, SeList, SeListGroup, SeListItem, SeLoading, SeRadio, SeRadioGroup, SeSidemenu, SeSidemenuItem, SeSlider, SeSnackbar, SeStepper, SeStepperItem, SeTabbar, SeTable, SeTableGroup, SeTableGroupHeader, SeTableItem, SeTableItemHeader, SeTooltip, SeTooltipContent, SeTooltipFooter, SeTooltipHeader, SeVisualLinear, SeVisualRadial]; }, imports: function () { return [CommonModule]; }, exports: function () { return [SeAbout, SeApp, SeAuthentication, SeBanner, SeBannerItem, SeBlock, SeBlockContent, SeBlockFooter, SeBlockHeader, SeBreadcrumb, SeBreadcrumbItem, SeButton, SeCheckbox, SeChip, SeContainer, SeDialog, SeDialogContent, SeDialogFooter, SeDialogHeader, SeDivider, SeDropdown, SeFab, SeFabItem, SeFormField, SeHeader, SeIcon, SeIconEcostruxure, SeIconLifeison, SeIconSchneider, SeLink, SeList, SeListGroup, SeListItem, SeLoading, SeRadio, SeRadioGroup, SeSidemenu, SeSidemenuItem, SeSlider, SeSnackbar, SeStepper, SeStepperItem, SeTabbar, SeTable, SeTableGroup, SeTableGroupHeader, SeTableItem, SeTableItemHeader, SeTooltip, SeTooltipContent, SeTooltipFooter, SeTooltipHeader, SeVisualLinear, SeVisualRadial]; } }); })();

/**
 * @fileoverview added by tsickle
 * Generated from: lib/snackbar/snackbar.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class SnackbarModule {
}
SnackbarModule.ɵfac = function SnackbarModule_Factory(t) { return new (t || SnackbarModule)(); };
SnackbarModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: SnackbarModule });
SnackbarModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [SnackbarService], imports: [CommonModule, ProxiesModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SnackbarModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule, ProxiesModule],
                declarations: [SnackbarComponent],
                entryComponents: [SnackbarComponent],
                providers: [SnackbarService]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(SnackbarModule, { declarations: function () { return [SnackbarComponent]; }, imports: function () { return [CommonModule, ProxiesModule]; } }); })();

/**
 * @fileoverview added by tsickle
 * Generated from: lib/dialog/dialog-config.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * \@description Configuration for opening dialog with the DialogService.
 */
class DialogConfig {
}
if (false) {
    /**
     * \@description title for the dialog
     * @type {?}
     */
    DialogConfig.prototype.title;
    /**
     * \@description message/content for the dialog
     * @type {?}
     */
    DialogConfig.prototype.message;
    /**
     * \@description icon value is passed to display in the content area
     * @type {?}
     */
    DialogConfig.prototype.icon;
    /**
     * \@description OK button text for the dialog
     * @type {?}
     */
    DialogConfig.prototype.textOK;
    /**
     * \@description Cancel button text for the dialog
     * @type {?}
     */
    DialogConfig.prototype.textCancel;
    /**
     * \@description size of the dialog: 'small'|'large'|'medium'|'fill'
     * @type {?}
     */
    DialogConfig.prototype.size;
    /**
     * \@description color of the dialog header: 'alternative'|'primary'
     * @type {?}
     */
    DialogConfig.prototype.color;
    /**
     * \@description icon color for the dialog if the icon is present:'alternative'|'primary'|'standard'|'secondary'
     * @type {?}
     */
    DialogConfig.prototype.iconColor;
    /**
     * \@description option for the dialog by removing the padding&margin before and after the content
     * @type {?}
     */
    DialogConfig.prototype.option;
    /**
     * \@description option to enable click on backdrop (`true`) or (`false`).  Default setting is `true`.
     * @type {?}
     */
    DialogConfig.prototype.canBackdrop;
    /**
     * \@description option to pass any data to the custom dialog component.
     * @type {?}
     */
    DialogConfig.prototype.data;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/dialog/dialog.directive.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class DialogDirective {
    /**
     * @param {?} viewContainerRef
     */
    constructor(viewContainerRef) {
        this.viewContainerRef = viewContainerRef;
    }
}
DialogDirective.ɵfac = function DialogDirective_Factory(t) { return new (t || DialogDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ViewContainerRef)); };
DialogDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: DialogDirective, selectors: [["", "seDialogTemplateInsertion", ""]] });
/** @nocollapse */
DialogDirective.ctorParameters = () => [
    { type: ViewContainerRef }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DialogDirective, [{
        type: Directive,
        args: [{
                selector: "[seDialogTemplateInsertion]"
            }]
    }], function () { return [{ type: ɵngcc0.ViewContainerRef }]; }, null); })();
if (false) {
    /** @type {?} */
    DialogDirective.prototype.viewContainerRef;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/dialog/dialog.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class DialogComponent {
    /**
     * @param {?} dialog
     */
    constructor(dialog) {
        this.dialog = dialog;
        this.afterClosed = new EventEmitter();
        // Web-component Event accessible from dialog service to call close/cancel function
        this.closeEvent = new EventEmitter();
    }
    /**
     * @return {?}
     */
    closeDialog() {
        this.closeEvent.emit(this.dialog);
    }
    /**
     * @return {?}
     */
    backdropClick() {
        this.closeEvent.error({ type: 'backdrop' });
    }
    /**
     * @return {?}
     */
    cancelDialog() {
        this.closeEvent.error({ type: 'cancel' });
    }
}
DialogComponent.ɵfac = function DialogComponent_Factory(t) { return new (t || DialogComponent)(ɵngcc0.ɵɵdirectiveInject(DialogConfig)); };
DialogComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: DialogComponent, selectors: [["se-ng-dialog"]], inputs: { type: "type" }, outputs: { afterClosed: "afterClosed", closeEvent: "closeEvent" }, decls: 6, vars: 10, consts: [["open", "true", 3, "color", "size", "canBackdrop", "didClose", "backdrop"], [4, "ngIf"], [3, "icon", "iconColor", "option"], [3, "innerHTML"], [3, "click"], ["color", "alternative", 3, "click"]], template: function DialogComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "se-dialog", 0);
        ɵngcc0.ɵɵlistener("didClose", function DialogComponent_Template_se_dialog_didClose_0_listener() { return ctx.closeDialog(); })("backdrop", function DialogComponent_Template_se_dialog_backdrop_0_listener() { return ctx.backdropClick(); });
        ɵngcc0.ɵɵtemplate(1, DialogComponent_se_dialog_header_1_Template, 2, 1, "se-dialog-header", 1);
        ɵngcc0.ɵɵelementStart(2, "se-dialog-content", 2);
        ɵngcc0.ɵɵelement(3, "div", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(4, DialogComponent_se_dialog_footer_4_Template, 3, 1, "se-dialog-footer", 1);
        ɵngcc0.ɵɵtemplate(5, DialogComponent_se_dialog_footer_5_Template, 5, 2, "se-dialog-footer", 1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("color", ctx.dialog.color)("size", ctx.dialog.size)("canBackdrop", ctx.dialog.canBackdrop);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.dialog.title);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("icon", ctx.dialog.icon)("iconColor", ctx.dialog.iconColor)("option", ctx.dialog.option);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("innerHTML", ctx.dialog.message, ɵngcc0.ɵɵsanitizeHtml);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.type === "alert");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.type === "confirm");
    } }, dependencies: [ɵngcc1.NgIf, SeButton, SeDialog, SeDialogContent, SeDialogFooter, SeDialogHeader] });
/** @nocollapse */
DialogComponent.ctorParameters = () => [
    { type: DialogConfig }
];
DialogComponent.propDecorators = {
    afterClosed: [{ type: Output }],
    closeEvent: [{ type: Output }],
    type: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DialogComponent, [{
        type: Component,
        args: [{ selector: 'se-ng-dialog', template: "  <se-dialog open=\"true\" [color]=\"dialog.color\" [size]=\"dialog.size\" (didClose)=\"closeDialog()\" (backdrop)=\"backdropClick()\" [canBackdrop]=\"dialog.canBackdrop\">\n   <se-dialog-header *ngIf=\"dialog.title\">{{dialog.title}}</se-dialog-header>\n    <se-dialog-content [icon]=\"dialog.icon\" [iconColor]=\"dialog.iconColor\" [option]=\"dialog.option\">\n      <div [innerHTML]=\"dialog.message\"></div>\n    </se-dialog-content>\n    <se-dialog-footer *ngIf=\"type==='alert'\">\n        <se-button (click)=\"closeDialog()\">{{dialog.textOK || 'Ok'}}</se-button>\n    </se-dialog-footer>\n    <se-dialog-footer *ngIf=\"type==='confirm'\">\n        <se-button (click)=\"cancelDialog()\" color=\"alternative\">{{dialog.textCancel || 'Cancel'}}</se-button>\n        <se-button (click)=\"closeDialog()\">{{dialog.textOK || 'Ok'}}</se-button>\n    </se-dialog-footer>\n  </se-dialog>\n" }]
    }], function () { return [{ type: DialogConfig }]; }, { afterClosed: [{
            type: Output
        }], closeEvent: [{
            type: Output
        }], type: [{
            type: Input
        }] }); })();
if (false) {
    /** @type {?} */
    DialogComponent.prototype.afterClosed;
    /** @type {?} */
    DialogComponent.prototype.closeEvent;
    /** @type {?} */
    DialogComponent.prototype.type;
    /** @type {?} */
    DialogComponent.prototype.dialog;
}
class DialogModalComponent {
    /**
     * @param {?} componentFactoryResolver
     * @param {?} cd
     * @param {?} modal
     */
    constructor(componentFactoryResolver, cd, modal) {
        this.componentFactoryResolver = componentFactoryResolver;
        this.cd = cd;
        this.modal = modal;
        this.afterClosed = new EventEmitter();
        // Web-component Event accessible from dialog service to call close/cancel function
        this.closeEvent = new EventEmitter();
    }
    /**
     * @return {?}
     */
    backdropClick() {
        this.closeEvent.error({ type: 'backdrop' });
    }
    /**
     * @return {?}
     */
    ngAfterViewInit() {
        if (this.childComponentType) {
            this.loadChildComponent(this.childComponentType);
            this.cd.detectChanges();
        }
    }
    /**
     * @param {?} componentType
     * @return {?}
     */
    loadChildComponent(componentType) {
        /** @type {?} */
        const componentFactory = this.componentFactoryResolver.resolveComponentFactory(componentType);
        /** @type {?} */
        const viewContainerRef = this.insertionPoint.viewContainerRef;
        viewContainerRef.clear();
        this.componentRef = viewContainerRef.createComponent(componentFactory);
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        if (this.componentRef) {
            this.componentRef.destroy();
        }
    }
}
DialogModalComponent.ɵfac = function DialogModalComponent_Factory(t) { return new (t || DialogModalComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ComponentFactoryResolver), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(DialogConfig, 8)); };
DialogModalComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: DialogModalComponent, selectors: [["se-dialog-modal"]], viewQuery: function DialogModalComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(DialogDirective, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.insertionPoint = _t.first);
    } }, outputs: { afterClosed: "afterClosed", closeEvent: "closeEvent" }, decls: 2, vars: 2, consts: [["open", "true", 3, "size", "canBackdrop", "backdrop"], ["seDialogTemplateInsertion", ""]], template: function DialogModalComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "se-dialog", 0);
        ɵngcc0.ɵɵlistener("backdrop", function DialogModalComponent_Template_se_dialog_backdrop_0_listener() { return ctx.backdropClick(); });
        ɵngcc0.ɵɵtemplate(1, DialogModalComponent_ng_template_1_Template, 0, 0, "ng-template", 1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("size", ctx.modal.size)("canBackdrop", ctx.modal.canBackdrop);
    } }, dependencies: [SeDialog, DialogDirective], encapsulation: 2 });
/** @nocollapse */
DialogModalComponent.ctorParameters = () => [
    { type: ComponentFactoryResolver },
    { type: ChangeDetectorRef },
    { type: DialogConfig, decorators: [{ type: Optional }] }
];
DialogModalComponent.propDecorators = {
    afterClosed: [{ type: Output }],
    closeEvent: [{ type: Output }],
    insertionPoint: [{ type: ViewChild, args: [DialogDirective, { static: false },] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DialogModalComponent, [{
        type: Component,
        args: [{
                selector: 'se-dialog-modal',
                template: "<se-dialog open=\"true\" [size]=\"modal.size\" [canBackdrop]=\"modal.canBackdrop\" (backdrop)=\"backdropClick()\">\n  <ng-template seDialogTemplateInsertion></ng-template>\n</se-dialog>\n"
            }]
    }], function () { return [{ type: ɵngcc0.ComponentFactoryResolver }, { type: ɵngcc0.ChangeDetectorRef }, { type: DialogConfig, decorators: [{
                type: Optional
            }] }]; }, { afterClosed: [{
            type: Output
        }], closeEvent: [{
            type: Output
        }], insertionPoint: [{
            type: ViewChild,
            args: [DialogDirective, { static: false }]
        }] }); })();
if (false) {
    /** @type {?} */
    DialogModalComponent.prototype.afterClosed;
    /** @type {?} */
    DialogModalComponent.prototype.closeEvent;
    /** @type {?} */
    DialogModalComponent.prototype.insertionPoint;
    /** @type {?} */
    DialogModalComponent.prototype.childComponentType;
    /** @type {?} */
    DialogModalComponent.prototype.componentRef;
    /**
     * @type {?}
     * @private
     */
    DialogModalComponent.prototype.componentFactoryResolver;
    /**
     * @type {?}
     * @private
     */
    DialogModalComponent.prototype.cd;
    /** @type {?} */
    DialogModalComponent.prototype.modal;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/dialog/dialog.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Injection token that can be used to access the data that was passed in to a dialog.
 * @type {?}
 */
const MODAL_DATA = new InjectionToken('ModalData');
class DialogService {
    /**
     * @param {?} componentFactoryResolver
     * @param {?} appRef
     * @param {?} injector
     */
    constructor(componentFactoryResolver, appRef, injector) {
        this.componentFactoryResolver = componentFactoryResolver;
        this.appRef = appRef;
        this.injector = injector;
        this.defaultConfig = {
            canBackdrop: true,
            color: 'primary',
            size: 'medium',
            data: {}
        };
    }
    /**
     * \@description method to create dialog component dynamically
     * @param {?} componentType
     * @param {?=} config
     * @return {?}
     */
    createDialogComponent(componentType, config = {}) {
        /** @type {?} */
        const userConf = Object.assign({}, this.defaultConfig, config)
        // MODAL_DATA added as DI based on config.data
        ;
        // MODAL_DATA added as DI based on config.data
        /** @type {?} */
        const map = new WeakMap([
            [MODAL_DATA, userConf.data]
        ]);
        map.set(DialogConfig, userConf);
        this.componentRef = this.componentFactoryResolver
            .resolveComponentFactory(componentType)
            .create(new ComponentInjector(this.injector, map));
        this.appRef.attachView(this.componentRef.hostView);
        /** @type {?} */
        const domElem = (/** @type {?} */ (((/** @type {?} */ (this.componentRef.hostView)))
            .rootNodes[0]));
        document.body.appendChild(domElem);
        return this.componentRef;
    }
    /**
     * \@description method to open alert dialog
     * @param {?} config
     * @return {?}
     */
    alert(config) {
        /** @type {?} */
        const dialogRef = this.createDialogComponent(DialogComponent, config);
        dialogRef.instance.type = 'alert';
        this.closeEvent = dialogRef.instance.closeEvent.subscribe((/**
         * @param {?} data
         * @return {?}
         */
        (data) => {
            this.close(data);
        }), (/**
         * @param {?} err
         * @return {?}
         */
        (err) => {
            this.cancel(err);
        }));
        return dialogRef;
    }
    /**
     * \@description method to open confirm dialog
     * @param {?} config
     * @return {?}
     */
    confirm(config) {
        /** @type {?} */
        const dialogRef = this.createDialogComponent(DialogComponent, config);
        dialogRef.instance.type = 'confirm';
        this.closeEvent = dialogRef.instance.closeEvent.subscribe((/**
         * @param {?} data
         * @return {?}
         */
        (data) => {
            this.close(data);
        }), (/**
         * @param {?} err
         * @return {?}
         */
        (err) => {
            this.cancel(err);
        }));
        return dialogRef;
    }
    /**
     * \@description method to open modal dialog
     * @param {?} componentType
     * @param {?=} config
     * @return {?}
     */
    modal(componentType, config) {
        /** @type {?} */
        const dialogRef = this.createDialogComponent(DialogModalComponent, config);
        this.closeEvent = dialogRef.instance.closeEvent.subscribe((/**
         * @param {?} data
         * @return {?}
         */
        (data) => {
            this.close(data);
        }), (/**
         * @param {?} err
         * @return {?}
         */
        (err) => {
            this.cancel(err);
        }));
        this.componentRef.instance.childComponentType = componentType;
        return dialogRef;
    }
    /**
     * \@description method to close the dialog by setting close property to true
     * @param {?} data
     * @return {?}
     */
    close(data) {
        this.componentRef.instance.afterClosed.emit(data);
        this.appRef.detachView(this.componentRef.hostView);
        this.componentRef.destroy();
        if (this.closeEvent) {
            this.closeEvent.unsubscribe();
        }
    }
    /**
     * \@description method to close the dialog by setting close property to true
     * @param {?} data
     * @return {?}
     */
    cancel(data) {
        this.componentRef.instance.afterClosed.error(data);
        this.appRef.detachView(this.componentRef.hostView);
        this.componentRef.destroy();
        if (this.closeEvent) {
            this.closeEvent.unsubscribe();
        }
    }
}
DialogService.ɵfac = function DialogService_Factory(t) { return new (t || DialogService)(ɵngcc0.ɵɵinject(ɵngcc0.ComponentFactoryResolver), ɵngcc0.ɵɵinject(ɵngcc0.ApplicationRef), ɵngcc0.ɵɵinject(ɵngcc0.Injector)); };
DialogService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: DialogService, factory: DialogService.ɵfac, providedIn: 'root' });
/** @nocollapse */
DialogService.ctorParameters = () => [
    { type: ComponentFactoryResolver },
    { type: ApplicationRef },
    { type: Injector }
];
/** @nocollapse */ DialogService.ngInjectableDef = ɵɵdefineInjectable({ factory: function DialogService_Factory() { return new DialogService(ɵɵinject(ComponentFactoryResolver), ɵɵinject(ApplicationRef), ɵɵinject(INJECTOR)); }, token: DialogService, providedIn: "root" });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DialogService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc0.ComponentFactoryResolver }, { type: ɵngcc0.ApplicationRef }, { type: ɵngcc0.Injector }]; }, null); })();
if (false) {
    /** @type {?} */
    DialogService.prototype.closeEvent;
    /** @type {?} */
    DialogService.prototype.defaultConfig;
    /** @type {?} */
    DialogService.prototype.componentRef;
    /**
     * @type {?}
     * @private
     */
    DialogService.prototype.componentFactoryResolver;
    /**
     * @type {?}
     * @private
     */
    DialogService.prototype.appRef;
    /**
     * @type {?}
     * @private
     */
    DialogService.prototype.injector;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/dialog/dialog.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class DialogModule {
}
DialogModule.ɵfac = function DialogModule_Factory(t) { return new (t || DialogModule)(); };
DialogModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: DialogModule });
DialogModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [DialogService], imports: [CommonModule, ProxiesModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DialogModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule, ProxiesModule],
                declarations: [DialogComponent, DialogModalComponent, DialogDirective],
                entryComponents: [DialogComponent, DialogModalComponent],
                providers: [DialogService]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(DialogModule, { declarations: function () { return [DialogComponent, DialogModalComponent, DialogDirective]; }, imports: function () { return [CommonModule, ProxiesModule]; } }); })();

/**
 * @fileoverview added by tsickle
 * Generated from: lib/page-loader/page-loader.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class PageLoaderComponent {
    constructor() { }
    /**
     * @return {?}
     */
    ngOnInit() { }
}
PageLoaderComponent.ɵfac = function PageLoaderComponent_Factory(t) { return new (t || PageLoaderComponent)(); };
PageLoaderComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: PageLoaderComponent, selectors: [["se-page-loader"]], decls: 1, vars: 0, consts: [["loading", "true", "fullPage", ""]], template: function PageLoaderComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelement(0, "se-loading", 0);
    } }, dependencies: [SeLoading], styles: [_c1] });
/** @nocollapse */
PageLoaderComponent.ctorParameters = () => [];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PageLoaderComponent, [{
        type: Component,
        args: [{ selector: 'se-page-loader', template: "<se-loading loading=\"true\" fullPage></se-loading>\n", styles: [":host{display:flex;flex-direction:column}"] }]
    }], function () { return []; }, null); })();

/**
 * @fileoverview added by tsickle
 * Generated from: lib/page-loader/page-loader.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class PageLoaderService {
    /**
     * @param {?} componentFactoryResolver
     * @param {?} applicationRef
     * @param {?} injector
     */
    constructor(componentFactoryResolver, applicationRef, injector) {
        this.componentFactoryResolver = componentFactoryResolver;
        this.applicationRef = applicationRef;
        this.injector = injector;
    }
    /**
     * @return {?}
     */
    show() {
        /** @type {?} */
        const componentFactory = this.componentFactoryResolver.resolveComponentFactory(PageLoaderComponent);
        /** @type {?} */
        const componentRef = componentFactory.create(new ComponentInjector(this.injector, new WeakMap()));
        this.applicationRef.attachView(componentRef.hostView);
        /** @type {?} */
        const domElement = (/** @type {?} */ (((/** @type {?} */ (componentRef.hostView))).rootNodes[0]));
        document.body.appendChild(domElement);
        this.pageLoaderComponentRef = componentRef;
    }
    /**
     * @return {?}
     */
    hide() {
        this.applicationRef.detachView(this.pageLoaderComponentRef.hostView);
        this.pageLoaderComponentRef.destroy();
    }
}
PageLoaderService.ɵfac = function PageLoaderService_Factory(t) { return new (t || PageLoaderService)(ɵngcc0.ɵɵinject(ɵngcc0.ComponentFactoryResolver), ɵngcc0.ɵɵinject(ɵngcc0.ApplicationRef), ɵngcc0.ɵɵinject(ɵngcc0.Injector)); };
PageLoaderService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: PageLoaderService, factory: PageLoaderService.ɵfac });
/** @nocollapse */
PageLoaderService.ctorParameters = () => [
    { type: ComponentFactoryResolver },
    { type: ApplicationRef },
    { type: Injector }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PageLoaderService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc0.ComponentFactoryResolver }, { type: ɵngcc0.ApplicationRef }, { type: ɵngcc0.Injector }]; }, null); })();
if (false) {
    /** @type {?} */
    PageLoaderService.prototype.pageLoaderComponentRef;
    /**
     * @type {?}
     * @private
     */
    PageLoaderService.prototype.componentFactoryResolver;
    /**
     * @type {?}
     * @private
     */
    PageLoaderService.prototype.applicationRef;
    /**
     * @type {?}
     * @private
     */
    PageLoaderService.prototype.injector;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/page-loader/page-loader.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class PageLoaderModule {
}
PageLoaderModule.ɵfac = function PageLoaderModule_Factory(t) { return new (t || PageLoaderModule)(); };
PageLoaderModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: PageLoaderModule });
PageLoaderModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [PageLoaderService], imports: [CommonModule, ProxiesModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PageLoaderModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule, ProxiesModule],
                declarations: [PageLoaderComponent],
                entryComponents: [PageLoaderComponent],
                providers: [PageLoaderService]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(PageLoaderModule, { declarations: function () { return [PageLoaderComponent]; }, imports: function () { return [CommonModule, ProxiesModule]; } }); })();

/**
 * @fileoverview added by tsickle
 * Generated from: lib/web.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class SeWebModule {
    /**
     * @return {?}
     */
    static forRoot() {
        return {
            ngModule: SeWebModule,
            providers: [
                {
                    provide: APP_INITIALIZER,
                    useFactory: appInitialize,
                    multi: true,
                    deps: [DOCUMENT]
                }
            ]
        };
    }
}
SeWebModule.ɵfac = function SeWebModule_Factory(t) { return new (t || SeWebModule)(); };
SeWebModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: SeWebModule });
SeWebModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [CommonModule,
        DialogModule,
        SnackbarModule,
        PageLoaderModule,
        ProxiesModule, ProxiesModule, SnackbarModule, DialogModule, PageLoaderModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SeWebModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    DialogModule,
                    SnackbarModule,
                    PageLoaderModule,
                    ProxiesModule
                ],
                declarations: [],
                providers: [],
                exports: [
                    ProxiesModule,
                    SnackbarModule,
                    DialogModule,
                    PageLoaderModule
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(SeWebModule, { imports: function () { return [CommonModule, DialogModule, SnackbarModule, PageLoaderModule, ProxiesModule]; }, exports: function () { return [ProxiesModule, SnackbarModule, DialogModule, PageLoaderModule]; } }); })();

/**
 * @fileoverview added by tsickle
 * Generated from: index.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: se-web-ui-angular.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { DialogConfig, DialogService, MODAL_DATA, PageLoaderService, SeAbout, SeApp, SeAuthentication, SeBanner, SeBannerItem, SeBlock, SeBlockContent, SeBlockFooter, SeBlockHeader, SeBreadcrumb, SeBreadcrumbItem, SeButton, SeCheckbox, SeChip, SeContainer, SeDialog, SeDialogContent, SeDialogFooter, SeDialogHeader, SeDivider, SeDropdown, SeFab, SeFabItem, SeFormField, SeHeader, SeIcon, SeIconEcostruxure, SeIconLifeison, SeIconSchneider, SeLink, SeList, SeListGroup, SeListItem, SeLoading, SeRadio, SeRadioGroup, SeSidemenu, SeSidemenuItem, SeSlider, SeSnackbar, SeStepper, SeStepperItem, SeTabbar, SeTable, SeTableGroup, SeTableGroupHeader, SeTableItem, SeTableItemHeader, SeTooltip, SeTooltipContent, SeTooltipFooter, SeTooltipHeader, SeVisualLinear, SeVisualRadial, SeWebModule, SnackbarService, DialogModule as ɵa, ProxiesModule as ɵb, DIRECTIVES as ɵc, ProxyCmp as ɵd, DialogComponent as ɵe, DialogModalComponent as ɵf, DialogDirective as ɵg, SnackbarModule as ɵh, SnackbarComponent as ɵi, SnackbarConfig as ɵj, PageLoaderModule as ɵk, PageLoaderComponent as ɵl, appInitialize as ɵm };

